const UnknownError: Error = {
	message: "Unknown error. Contact an engineer.",
	name: "UnknownError"
}

export default UnknownError
